import type { AxiosResponse } from 'axios';
import apiClient from './apiClient';

export type RequestType = 'post' | 'patch';

export default async function sendAuthenticatedToBackend<T>(
  path: string,
  method: RequestType,
  data: T
): Promise<AxiosResponse> {
  if (method === 'post') {
    return apiClient.post(`/${path}`, data);
  }
  return apiClient.patch(`/${path}`, data);
}
